import { render } from "./NewQueryItem.vue?vue&type=template&id=b6310a9c"
import script from "./NewQueryItem.vue?vue&type=script&lang=js"
export * from "./NewQueryItem.vue?vue&type=script&lang=js"

import "./NewQueryItem.vue?vue&type=style&index=0&id=b6310a9c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__